import { useEffect } from 'react';

const Docs = () => {
  useEffect(() => {
    // Perform a full-window redirect to the static documentation entry point.
    // This bypasses X-Frame-Options: deny restrictions.
    window.location.href = '/docs/index.html';
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-white dark:bg-gray-950">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600 dark:text-gray-400 font-medium">Loading Documentation...</p>
      </div>
    </div>
  );
};

export default Docs;
